import type { CssRule, CssDeclaration, CssRoot, CssAtRule, CssNode } from './types'

export const buildCssRoot = (): CssRoot => ({ nodes: [] })

export const buildCssRule = (selector: string, nodes: CssNode[] = []): CssRule => ({ selector, nodes, type: 'rule' })

export const buildCssAtRule = (name: string, options: { params?: string; nodes?: CssNode[] }): CssAtRule => ({
    name,
    params: options.params,
    nodes: options.nodes ?? [],
    type: 'at-rule',
})

export const buildCssDeclaration = (prop: string, value: string): CssDeclaration => ({
    prop,
    value,
    type: 'declaration',
})
